<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="900" scrollable>
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon color="warning" class="mr-2">mdi-database-sync</v-icon>
        ตรวจสอบและปรับปรุงข้อมูลค้าง (กรณีโยกย้าย/สับเปลี่ยน)
        <v-spacer />
        <v-btn icon @click="$emit('input', false)"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>

      <v-card-text>
        <v-alert text color="info" dense class="mb-4">
          ตรวจสอบรายชื่อพนักงานราชการที่เคยโยกย้าย/สับเปลี่ยนผ่านระบบ แต่ข้อมูลในตาราง
          "ข้อมูลบุคคล"/"อัตรากำลัง" (หน้านี้และหน้าสรุปอัตรากำลัง) ยังไม่อัปเดตตามสังกัดจริง —
          กดปรับปรุงเพื่ออัปเดตให้ตรงกับสถานศึกษาปลายทางปัจจุบัน <strong>ไม่มีการลบข้อมูลใดๆ ทั้งสิ้น</strong>
          รายการที่ย้าย "ออกจาก" สถานศึกษานี้จะหายจากรายการของที่นี่ (เพราะย้ายไปสังกัดที่อื่นแล้วจริง)
          แต่ข้อมูลยังอยู่ครบที่สถานศึกษาปลายทาง
        </v-alert>

        <div v-if="loading" class="text-center py-8">
          <v-progress-circular indeterminate color="primary" />
          <div class="mt-2 grey--text">กำลังตรวจสอบ...</div>
        </div>

        <div v-else-if="!items.length" class="text-center py-8 grey--text">
          <v-icon size="48" color="success">mdi-check-circle-outline</v-icon>
          <div class="mt-2">ไม่พบข้อมูลที่ค้างอยู่ ข้อมูลถูกต้องตรงกันแล้ว</div>
        </div>

        <v-simple-table v-else dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th>ชื่อ-สกุล</th>
                <th>เลขบัตรประชาชน</th>
                <th>สังกัดที่ถูกต้องตอนนี้</th>
                <th>ข้อมูลบุคคล (personnel_temporary)</th>
                <th>ข้อมูลอัตรากำลัง (personnel_etc)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="it in items" :key="it.id_card">
                <td>{{ it.full_name || "-" }}</td>
                <td>{{ it.id_card }}</td>
                <td><strong>{{ it.correct_college }}</strong> / {{ it.correct_position }}</td>
                <td>
                  <v-chip v-if="!it.personnel_temporary" x-small outlined color="grey">ไม่มีข้อมูล</v-chip>
                  <v-chip v-else-if="it.personnel_temporary.mismatch" x-small color="error" dark>
                    ค้างที่ {{ it.personnel_temporary.college_code }} / {{ it.personnel_temporary.id_position }}
                  </v-chip>
                  <v-chip v-else x-small color="success" dark>ตรงกันแล้ว</v-chip>
                </td>
                <td>
                  <v-chip v-if="!it.personnel_etc" x-small outlined color="grey">ไม่มีข้อมูล</v-chip>
                  <v-chip v-else-if="it.personnel_etc.mismatch" x-small color="error" dark>
                    ค้างที่ {{ it.personnel_etc.college_code }} / {{ it.personnel_etc.id_position }}
                  </v-chip>
                  <v-chip v-else x-small color="success" dark>ตรงกันแล้ว</v-chip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>

      <v-card-actions>
        <v-btn text :disabled="loading || applying" @click="$emit('refresh')">
          <v-icon left small>mdi-refresh</v-icon>ตรวจสอบใหม่
        </v-btn>
        <v-spacer />
        <v-btn text @click="$emit('input', false)">ปิด</v-btn>
        <v-btn
          v-if="items.length"
          color="warning"
          :loading="applying"
          @click="$emit('apply-all')"
        >
          <v-icon left small>mdi-content-save-check</v-icon>
          ปรับปรุงข้อมูลทั้งหมด ({{ items.length }} รายการ)
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ReconcileDialog",
  props: {
    value: { type: Boolean, default: false },
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    applying: { type: Boolean, default: false }
  }
};
</script>
